<template>
  <div class="qr-wrapper">
    <div v-if="!hasPermissions">Для сканирования qr-code необходимо разрешить использование камеры</div>

    <div
      v-else-if="qrCheckinIsSuccess"
      class="qr-wrapper__success-checkin-wrapper flex-container justify-center align-center"
    >
      <p class="mb-0">Вы можете закрыть эту страницу и вернуться к использованию приложения</p>
    </div>

    <div v-else class="qr-wrapper__main-content">
      <div v-if="userHasMasterQrPermission" class="qr-wrapper__buttons flex-container justify-space-between">
        <v-btn
          v-for="(button, index) in toggleButtons"
          :key="index"
          :color="activeScanType === button.value ? 'primary' : 'white'"
          class="qr-wrapper__buttons-item pl-btn-toggle mx-0"
          @click="activeScanType = button.value"
        >
          {{ button.label }}
        </v-btn>
      </div>

      <div :class="{ 'master-qr-bg': activeScanType === 'masterQr' }" />

      <div v-if="showCommentField" class="qr-wrapper__comment-wrapper">
        <div>
          <p class="q-mb-sm">Пояснение к применению Мастер QR</p>

          <label>
            <textarea v-model="qrMasterComment" class="qr-wrapper__comment-field" />
          </label>

          <v-btn class="qr-wrapper__submit-comment" color="secondary" @click="submitQrMasterComment">
            Подтвердить
          </v-btn>
        </div>
      </div>

      <qrcode-stream :key="scanId" @decode="onDecode($event)" />

      <div class="qr-wrapper__buttons qr-wrapper__refresh-button-wrapper flex-container justify-center">
        <v-btn @click="refreshQrScanWindow">Обновить страницу</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { checkinQr, checkinGeneralQr, checkQrsPermission } from '@/api/checkins'

function getGeoposition() {
  return new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(
      position => resolve(position.coords),
      () => resolve({ latitude: 0, longitude: 0 }),
    )
  })
}

function genScanId() {
  return Math.floor(Math.random() * 10000)
}

export default {
  components: {
    QrcodeStream,
  },
  data: () => ({
    scanId: genScanId(),
    result: '',
    error: '',
    routeParams: {},
    qrMasterComment: '',
    qrCheckinIsSuccess: false,
    userHasMasterQrPermission: false,
    activeScanType: 'default',
    showCommentField: false,
    toggleButtons: [
      {
        label: 'Скан QR',
        value: 'default',
      },
      {
        label: 'Мастер QR',
        value: 'masterQr',
      },
    ],
    hasPermissions: false,
  }),
  async created() {
    const currentHref = window.location.href
    const triggerPart = 'crm-staging.pilki.com'

    // if (currentHref.indexOf(triggerPart) !== -1) {
    //   window.location.href = currentHref.replace(triggerPart, 'crm.pilki.com')
    // }

    const res = await window.navigator.permissions.query({ name: 'camera' })

    if (res.state === 'granted') {
      this.hasPermissions = true
    }
  },
  async mounted() {
    this.routeParams = this.$route.query

    this.userHasMasterQrPermission = await checkQrsPermission(this.routeParams.token)
  },
  methods: {
    showGeopositionPermissionError() {
      this.$notify({
        type: 'error',
        text: 'Для того, чтобы использовать QR-код, пожалуйста, разрешите браузеру определять вашу геопозицию',
        group: 'hasBottomNavigation',
      })
    },
    async onDecode(result) {
      alert('onDecode', result)
      try {
        const { latitude, longitude } = await getGeoposition()

        this.result = {
          ...JSON.parse(result),
          latitude,
          longitude,
        }

        if (this.activeScanType === 'default') {
          await this.checkinQrHandler(this.result)
        } else {
          this.showCommentField = true
        }
      } catch {
        this.scanId = genScanId()
      }
    },
    async submitQrMasterComment() {
      this.showCommentField = false
      this.result.comment = this.qrMasterComment

      await this.checkinQrHandler(this.result)
    },
    async checkinQrHandler(checkinData) {
      let notifyObject = {}

      try {
        const apiServiceMethod = checkinData.hasOwnProperty('unit_id') ? checkinGeneralQr : checkinQr
        const message = await apiServiceMethod({
          checkinData,
          token: this.routeParams.token,
        })

        notifyObject.type = message.indexOf('Опоздание') !== -1 ? 'warning' : 'success'
        notifyObject.text = message

        this.qrCheckinIsSuccess = true
      } catch ({ data }) {
        notifyObject.type = 'error'
        notifyObject.text = data.message
      } finally {
        this.$notify({
          ...notifyObject,
          group: 'hasBottomNavigation',
        })
      }
    },
    refreshQrScanWindow() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.qr-wrapper {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  &__main-content {
    height: 100%;
  }

  &__success-checkin-wrapper {
    height: 100%;
    width: 100%;

    p {
      text-align: center;
      padding: 0 10%;
      font-size: 20px;
    }
  }

  &__buttons {
    position: absolute;
    z-index: 1000;
    width: 100%;
    padding: 20px;
  }

  &__refresh-button-wrapper {
    bottom: 50px;
  }

  &__buttons-item {
    width: calc((100% - 20px) / 2);
  }

  &__comment-wrapper {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 3000;
    display: flex;
    justify-content: center;
    padding-top: 100px;

    & > div {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 500px;
      padding: 0 20px 20px;
      text-align: center;

      & > label {
        flex: 1;
        max-height: 300px;
      }
    }
  }

  &__comment-field {
    width: 100%;
    height: 100%;
    border: 2px solid #000;
    border-radius: 10px;
    padding: 10px;
    font-size: 16px;
  }

  &__submit-comment {
    display: block;
    margin: 10px auto 0;
  }

  .master-qr-bg {
    z-index: 500;
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: red;
    opacity: 0.4;
  }
}
</style>
